import { render, staticRenderFns } from "./GeneratePdfButton.vue?vue&type=template&id=094caa4c&"
import script from "./GeneratePdfButton.vue?vue&type=script&lang=js&"
export * from "./GeneratePdfButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('094caa4c')) {
      api.createRecord('094caa4c', component.options)
    } else {
      api.reload('094caa4c', component.options)
    }
    module.hot.accept("./GeneratePdfButton.vue?vue&type=template&id=094caa4c&", function () {
      api.rerender('094caa4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/CustomerInvoices/buttons/GeneratePdfButton.vue"
export default component.exports